import { ProfanityCheckRule } from '@/types/profanity'
import axios from './orderInstance'

// Updates the selected company's existing profanity policy (PUT replaces max_score + rules).
const updateProfanityCheckRule = async (rule: ProfanityCheckRule) => {
  const response = await axios.put('/profanity-check-rules/', rule)
  return response.data
}

export default updateProfanityCheckRule
